module.exports = __webpack_public_path__ + "img/61.118908c9.jpg";